import React, { Component } from 'react'
import firebase from 'firebase/app'
import 'firebase/firestore'

const config = {
    apiKey: "AIzaSyCU4R2prh3JN2olEBmtWuaBut6yccuRoEQ",
    databaseURL:"https://mookmark-f5fca.firebaseio.com",
    projectId:"mookmark-f5fca",
}

const extract = (string) => {
    if (!string) {
        return;
    }
    const matches = string.match(/\bhttps?:\/\/\S+/gi);
    console.log(matches);
    if (!matches) {
        return;
    }
    return matches[0];
}

const check = (fields) => {
    const found = fields.map(extract).filter(v => v)
    return found.length > 0 && found[0]
}

class Marks extends Component {
    constructor(props) {
        super(props)
        this.state = { marks : [], loaded: false, share: null }
        this.fb = firebase.initializeApp(config)
        this.db = firebase.firestore()
    }
    componentDidMount() {
        const parsedUrl = new URL(window.location);

        const title = parsedUrl.searchParams.get('title')
        const text = parsedUrl.searchParams.get('text')
        const url = parsedUrl.searchParams.get('url')

        if (title || text || url) {
            this.setState({share:{title, text, url, link: check([title, text, url])}})
        }
        this.db.collection("mookmarks").get().then((querySnapshot) => {
            this.setState({loaded:true, marks : []})
            querySnapshot.forEach((doc) => {
                this.setState({marks:[...this.state.marks, {...doc.data()}]})
            });
        });
    }

    render() {
        const {marks, loaded, share}  = this.state;
        const sortedMarks = marks
            .map(a=>{ return {...a, ts: +new Date(a.created_at.seconds * 1000)}})
            .sort((a,b)=>(b.ts-a.ts))
            .map(mark => <Mark key={mark.ts} {...mark} />)
        return <ul>
            {share && <Shared db={this.db} {...share} />}
            {!loaded && <div className="loading">Loading...</div>}
            {loaded && sortedMarks}
        </ul>
    }
}

const Mark = ({text, link, created_at, ts}) => (
    <li><a href={link}><div>{text}</div> <aside><CreationDate ts={ts} /></aside></a></li>
)

const CreationDate = ({ts}) => {
    return new Date(ts).toLocaleDateString("fr-FR")

}
class Shared extends Component {
    constructor(props) {
        super(props)
        this.state = {added: false}
    }
    submit() {
        this.setState({submitting:true})
        const text = this._title.value
        const link = this._link.value
        const created_at = new Date()

        this.props.db.collection("mookmarks").add({text, link, created_at})
            .then(()=>{
                this.setState({added:true, submitting:false})
            })
            .catch((err)=>alert(err))
    }
    render() {
        if (this.state.added) {
            return <span>✓ Link added successfully</span>;
        }
        if (this.state.submitting) {
            return <span>Saving</span>;
        }
        const {title, text, url, link} = this.props
        return <div className={"shared"}>
            <ul className={"shared-info"}>
                <li><span>Title:</span> {title}</li>
                <li><span>Text:</span> {text}</li>
            </ul>
            <div>
                <input type="text" defaultValue={title} ref={r=>this._title = r}/>
            </div>
            <div>
                <input type="text" defaultValue={link} ref={r=>this._link = r}/>
            </div>
            <div className={"shared-submit"}><button onClick={this.submit.bind(this)}>Add</button></div>
        </div>
    }
}

export default Marks;
